import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FullQuiz = () => {
    const navigate = useNavigate();

    const questions = [
        {
            question: 'Are you ready babe!?',
            options: ['Yes', 'No'],
            correctAnswerIndexes: [0],
            correctAnswerText: 'Good luck!',
            incorrectAnswerText: 'I think you mis-clicked babe :)',
        },
        {
            question: "Let's start with an easy one. How did we meet?",
            options: ['Through friends', 'Tinder', 'Grocery Store', 'Dog park'],
            correctAnswerIndexes: [1],
            correctAnswerText: 'Correct! We met "Online"',
            incorrectAnswerText: "It's not 2012 anymore, we can be honest :)",
        },
        {
            question: 'What was our first message about?',
            options: ['Vietnam picture', 'Just "Hey"', 'Pets', 'The Coast Guard'],
            correctAnswerIndexes: [0],
            correctAnswerText: 'Correct! The vibes babe, the vibes!',
            incorrectAnswerText: 'Imagine if I just said "hey"? Boy could things have been different..',
        },
        {
            question: 'Where did we go for our first date?',
            options: ['Movies', 'Minigolf', 'Diner', 'My place'],
            correctAnswerIndexes: [2],
            correctAnswerText: 'One of the best nights of my life :)',
            incorrectAnswerText: 'We got to this one eventually!',
        },
        {
            question: 'What has been our lucky number?',
            options: ['1', '17', '8', '7'],
            correctAnswerIndexes: [3],
            correctAnswerText: 'Lucky 7 babe! So many 7\'s... lol',
            incorrectAnswerText: 'Not lucky enough!',
        },
        {
            question: 'Where did we go for our first vacation?',
            options: ['Myrtle Beach', 'Montreal', 'Chicago', 'Florida'],
            correctAnswerIndexes: [0],
            correctAnswerText: 'That was an easy one. We will get to the others <3',
            incorrectAnswerText: 'Not yet, but we will!',
        },
        {
            question: 'Who said "I love you" first?',
            options: ['We haven\'t said it yet', 'We said it at the same time', 'Sage', 'Tom'],
            correctAnswerIndexes: [3],
            correctAnswerText: '"Wait, what did you say?" 😂',
            incorrectAnswerText: 'I thought this would be an easy one lol',
        },
        {
            question: 'After which date was our first kiss?',
            options: ['Dinner at home', 'The Fair', 'Druthers', 'Diner'],
            correctAnswerIndexes: [1],
            correctAnswerText: 'It should have been sooner but I got there.. lol',
            incorrectAnswerText: 'Try again!',
        },
        {
            question: 'What was the first gift I bought you?',
            options: ['T-shirt', 'Halloween Grogu pin', 'A mug', 'Printed Photo'],
            correctAnswerIndexes: [1],
            correctAnswerText: 'I combined Star Wars and Halloween, you\'re favorite things!',
            incorrectAnswerText: 'Hint, I gave it to you at the fair',
        },
        {
            question: 'What day did you find out and tell me you were pregnant?',
            options: ['March 21nd', 'March 6th', 'April 7th', 'April 27th'],
            correctAnswerIndexes: [3],
            correctAnswerText: 'Let\'s go! We are having a baby 👶',
            incorrectAnswerText: '',
        },
        {
            question: 'How much do I love you?',
            options: ['Forever is not enough time to tell you!', 'More than you know!', 'Infinite♾️'],
            correctAnswerIndexes: [0, 1, 2],
            correctAnswerText: 'Trick question, it\'s all of them. Love you forever baby!!',
            incorrectAnswerText: '',
        },
    ];

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null);
    const [feedback, setFeedback] = useState('');
    const [wasCorrect, setWasCorrect] = useState(null);
    const [showNext, setShowNext] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const currentQuestion = questions[currentQuestionIndex];

    const handleChange = (index) => {
        setSelectedAnswerIndex(index);
    };

    const handleSubmit = () => {
        if (selectedAnswerIndex === null) return;

        if (currentQuestion.correctAnswerIndexes.includes(selectedAnswerIndex)) {
            setFeedback(currentQuestion.correctAnswerText);
            setWasCorrect(true);
            setShowNext(true);
        } else {
            setFeedback(currentQuestion.incorrectAnswerText);
            setWasCorrect(false);
        }
    };

    const handleNext = () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setSelectedAnswerIndex(null);
            setFeedback('');
            setWasCorrect(null);
            setShowNext(false);
            setCurrentQuestionIndex((prev) => prev + 1);
            setIsTransitioning(false);
        }, 300);
    };

    const handleFinish = () => {
        navigate('/quizfinal');
    };

    return (
        <div style={styles.container}>
            <div
                style={{
                    ...styles.quizBox,
                    opacity: isTransitioning ? 0 : 1,
                    transition: 'opacity 0.3s ease',
                }}
            >
                <h2>{currentQuestion.question}</h2>

                {currentQuestion.options.map((option, index) => (
                    <label key={index} style={styles.optionLabel}>
                        <input
                            type="radio"
                            name={`question-${currentQuestionIndex}`}
                            value={index}
                            checked={selectedAnswerIndex === index}
                            onChange={() => handleChange(index)}
                        />
                        {option}
                    </label>
                ))}

                <div style={styles.buttonContainer}>
                    {!showNext ? (
                        <button onClick={handleSubmit} style={styles.button}>
                            Submit
                        </button>
                    ) : currentQuestionIndex < questions.length - 1 ? (
                        <button onClick={handleNext} style={styles.button}>
                            Next Question
                        </button>
                    ) : (
                        <button onClick={handleFinish} style={styles.button}>
                            Finish Quiz
                        </button>
                    )}

                    {feedback && (
                        <p
                            style={{
                                color: wasCorrect ? 'green' : 'red',
                                marginTop: '8px',
                                textAlign: 'center',
                            }}
                        >
                            {feedback}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        height: '100vh',
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#78866B',
        boxSizing: 'border-box',
    },
    quizBox: {
        padding: '30px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        width: '90%',
        maxWidth: '400px',
        textAlign: 'left',
        overflowWrap: 'break-word',
        boxSizing: 'border-box',
    },
    optionLabel: {
        display: 'block',
        margin: '10px 0',
        cursor: 'pointer',
        wordBreak: 'break-word',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        marginTop: '20px',
        gap: '12px',
    },
    button: {
        padding: '12px',
        fontSize: '16px',
        backgroundColor: '#4CAF50',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        width: '100%',
    },
};

export default FullQuiz;